import { render, staticRenderFns } from "./FormDivision.vue?vue&type=template&id=57cd30a7"
import script from "./FormDivision.vue?vue&type=script&lang=js"
export * from "./FormDivision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormDivision.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cd30a7')) {
      api.createRecord('57cd30a7', component.options)
    } else {
      api.reload('57cd30a7', component.options)
    }
    module.hot.accept("./FormDivision.vue?vue&type=template&id=57cd30a7", function () {
      api.rerender('57cd30a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormDivision.vue"
export default component.exports